import React from "react";
import MyCalendar from "../../components/Calendar/MyCalendar";

function BookingCalendar() {
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>Booking Calendar</h4>
              <h6>Manage Booking Calendar</h6>
            </div>
          </div>
          {/* <>additional data</> */}
        </div>
        <div className="card">
          <div className="card-body">
            <MyCalendar />
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingCalendar;
